export const QueryParamStrings = {
  InvoiceTemplate: "templateInvoice",
  RecurringInvoiceTemplate: "templateRecurringInvoice",
  SelfInvoiceTemplate: "templateSelfInvoice",
  IsSelfInvoice: "isSelfInvoice",
  IsCredit: "isCredit",
  Recurring: "recurring",
  IsRecurring: "isRecurring",
  QuotationTemplate: "quotationTemplate",
  Section: "section",
};

export const QuotationQueryParams = {
  QuotationTemplate: "templateQuotation",
  IsEdit: "isEdit",
};

export const DeadlineQueryParams = {
  DeadlineId: "deadlineId",
};

export const TimeReportingQueryParams = {
  EmployeeId: "employeeId",
  CurrentDate: "currentDate",
  Period: "period",
};

export const IncomingInvoiceQueryParams = {
  SuppliersIds: "suppliersIds",
  SuppliersNames: "suppliersNames",
};

export const TaxAgentName = "Skatteverket";
